import { useContext, useEffect, useState } from "react";
import { CachedTokenContext } from "@seabrookstudios/auth";
import { useMyProfile } from "@seabrookstudios/pitch2table";

/**
 * Hook to check if the logged-in user owns the content being viewed
 * by comparing their username (slug) with the username in the URL.
 * Does not force authentication - returns null if not authenticated.
 *
 * @param {string} username - The username from the URL
 * @returns {boolean | null} - true if user owns the content, false if not, null if not authenticated or still loading
 */
export const useIsOwnContent = (username) => {
  try {
    const token = useContext(CachedTokenContext);
    const isAuthenticated = token !== "";
    const { data: profile } = useMyProfile();

    // Not authenticated - return null to indicate we don't know
    if (!isAuthenticated) {
      return null;
    }

    // Still loading profile or no profile available
    if (!profile) {
      return null;
    }

    // Check if the username matches the logged-in user's slug
    return profile.slug === username;
  } catch (_e) {
    return null;
  }
};

/**
  }
 * @param {import("@tanstack/react-query").UseMutationResult<void, Error, void>} mutation
 * @param {string} username
 */
export const useInvokeOnceWhenNotOwn = (mutation, username) => {
  const isOwnContent = useIsOwnContent(username);
  const [called, setCalled] = useState(false);

  useEffect(() => {
    if (called) {
      return;
    }

    if (isOwnContent !== true) {
      setCalled(true);
      mutation.mutateAsync();
    }
  }, [isOwnContent]);
};
